import axios from "axios"
import apiMixin from "@/mixins/apiMixin";

const BrandCentre = {
    namespaced: true,
    state: {
        availableProjects: [],
        currentProject: {},
        projectDescription: {},
        wordBank: [],
        brandBank: [],
        brandCentreVisibility: false,
    },
    getters: {
        getWordBankWords(state) {
            return state.wordBank;
        },
        getBrandBankWords(state) {
            return state.brandBank;
        },
        getAvailableProject(state) {
            return state.availableProjects;
        },
        getCurrentProject(state) {
            return state.currentProject;
        },
        getProjectDescription(state) {
            return state.projectDescription;
        },
        getBrandCentreVisibility(state) {
            return state.brandCentreVisibility;
        }
    },
    mutations: {
        setWordBankState(state, payload) {
            state.wordBank = payload;
        },
        setBrandBankState(state, payload) {
            state.brandBank = payload;
        },
        setAvailableProjectsState(state, payload) {
            state.availableProjects = payload;
        },
        setCurrentProjectState(state, payload) {
            state.currentProject = payload;
        },
        setProjectDescription(state, payload) {
            state.projectDescription = payload;
        },
        setBrandCentreVisibility(state, payload) {
            state.brandCentreVisibility = payload;
        }
    },
    actions: {
        removeWordBankWord({ commit, state, dispatch }, word) {
            const wordBank = [...state.wordBank];

            // if we only have the word from the accordion checkbox click event. We find the words data from the bank
            if (typeof word !== 'object') {
                word = wordBank.find(item => item.name === word);
            }

            const newWordBankArray = wordBank.filter(item => item.name !== word.name);

            commit('setWordBankState', newWordBankArray);

            axios.delete(`${process.env.VUE_APP_API_ROOT_URL}/api/project/${state.currentProject.value}/word/${word.id}`, {
                headers: apiMixin.methods.getHeaders(),
            })
                .catch(function (error) {
                    console.log(error);
                    // if removal failed add the word back in
                    dispatch('addWordToWordBank', word.name);
                });
        },
        removeBrandBankWord({ commit, state, dispatch }, word) {
            const brandBank = [...state.brandBank];
            const newBrandBankArray = brandBank.filter(item => item.name !== word.name);

            commit('setBrandBankState', newBrandBankArray);

            axios.delete(`${process.env.VUE_APP_API_ROOT_URL}/api/project/${state.currentProject.value}/brand/${word.id}`, {
                headers: apiMixin.methods.getHeaders(),
            })
                .catch(function (error) {
                    console.log(error);
                    // if removal failed add the word back in
                    dispatch('addWordToBrandBank', word.name);
                });
        },
        addWordToBrandBank({ commit, state }, word) {
            if (state.currentProject.value) {
                axios.post(`${process.env.VUE_APP_API_ROOT_URL}/api/project/${state.currentProject.value}/brand`, {
                    name: word,
                },
                    {
                        headers: apiMixin.methods.getHeaders(),
                    }
                )
                    .then(function (response) {
                        const brandAdded = response.data;
                        const newBrandBankArray = [...state.brandBank, brandAdded];

                        commit('setBrandBankState', newBrandBankArray);
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            }

        },
        addWordToWordBank({ commit, state }, word) {
            axios.post(`${process.env.VUE_APP_API_ROOT_URL}/api/project/${state.currentProject.value}/word`, {
                name: word,
            },
                {
                    headers: apiMixin.methods.getHeaders(),
                }
            )
                .then(function (response) {
                    const brandAdded = response.data;
                    const newWordBankArray = [...state.wordBank, brandAdded];

                    commit('setWordBankState', newWordBankArray);
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        changeCurrentProject({ commit }, projectID) {
            axios.get(`${process.env.VUE_APP_API_ROOT_URL}/api/project/${projectID}`, {
                headers: apiMixin.methods.getHeaders(),
            })
                .then(function (response) {
                    const data = response.data;
                    const words = data.words;
                    const brands = data.brands;

                    const currentProject = {
                        label: data.name,
                        value: data.id
                    };

                    commit('setWordBankState', words);
                    commit('setBrandBankState', brands);
                    commit('setCurrentProjectState', currentProject);
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        getProjects({ commit }) {
            axios.get(`${process.env.VUE_APP_API_ROOT_URL}/api/project`, {
                headers: apiMixin.methods.getHeaders(),
            })
                .then(function (response) {
                    const data = response.data;
                    let projects = [];

                    // create object compatible with vueformulate select input
                    for (let i = 0; i < data.length; i++) {
                        projects.push({
                            label: data[i].name,
                            value: data[i].id,
                        });
                    }

                    commit('setAvailableProjectsState', projects);
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        createProject({ commit, state }, projectName) {
            axios.post(`${process.env.VUE_APP_API_ROOT_URL}/api/project`, {
                name: projectName,
            },
                {
                    headers: apiMixin.methods.getHeaders(),
                }
            )
                .then(function (response) {
                    const data = response.data;
                    // setting current project in formulatevue select input formatting
                    const newProject = {
                        label: data.name,
                        value: data.id
                    };
                    const newAvailableProjectsArray = [...state.availableProjects, newProject];

                    commit('setAvailableProjectsState', newAvailableProjectsArray);
                    commit('setCurrentProjectState', newProject);
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        deleteProject({ commit, state }, projectID) {
            axios.delete(`${process.env.VUE_APP_API_ROOT_URL}/api/project/${projectID}`, {
                headers: apiMixin.methods.getHeaders(),
            })
                .then(function (response) {
                    const removedProjectData = response.data;
                    const availableProjects = state.availableProjects;
                    const newAvailableProjectsArray = availableProjects.filter((project) => {
                        return project.value != removedProjectData.id;
                    });

                    commit('setAvailableProjectsState', newAvailableProjectsArray);
                    commit('setCurrentProjectState', {});
                    commit('setWordBankState', []);
                    commit('setBrandBankState', []);
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        toggleBrandCentreVisibility({commit, state}) {
            const newBrandCentreVisibility = !state.brandCentreVisibility;

            commit('setBrandCentreVisibility', newBrandCentreVisibility);
        },
        clearSelectedProject({ commit }) {
            commit('setCurrentProjectState', {});
            commit('setWordBankState', []);
            commit('setBrandBankState', []);
        },
        setProjectName({ commit }, projectName) {
            commit('setCurrentProjectState', {
                label: projectName
            });
        }
    }
}

export default BrandCentre;